import { render, staticRenderFns } from "./NoEnviaronTabla.vue?vue&type=template&id=1222b72a&scoped=true&"
import script from "./NoEnviaronTabla.vue?vue&type=script&lang=js&"
export * from "./NoEnviaronTabla.vue?vue&type=script&lang=js&"
import style0 from "./NoEnviaronTabla.vue?vue&type=style&index=0&id=1222b72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222b72a",
  null
  
)

export default component.exports